import * as _ from "lodash";
import moment from "moment";
import React, {Fragment, Component} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {
    ClickAwayListener,
    InputAdornment,
    TextField,
} from '@material-ui/core';
import {Form as DateTimeForm} from "../../vendors/redux/reducers/dateTime";
import {dateTimeFormChange, dateTimeFormReset} from '../../vendors/actions/dateTime';

const DatetimeComponent = require('react-datetime');


interface OwnProps {
    default?: {
        time: any,
        zone: string
    }
    className?: any
}

interface ConnectStateProps {
    DateTime: DateTimeForm,
    CaseForm: any
}

interface MainState {
    open: boolean,
    countyTimeZone: string
}

interface ConnectDispatchProps {
    dateTimeFormChange: (data: any) => void;
    dateTimeFormReset: () => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

const op: {
    [key: string]: any
} = {
    today: moment().set({h: 6, m: 45}).toDate(),
    defaultTime: moment().set({h: 7, m: 0}).toDate(),
    defaultTimePM: moment().set({h: 12, m: 0}).toDate(),
    yesterday: moment().subtract(1, 'day'),
    disabledHours: {
        AM: 7,
        PM: 18
    },
    disabledMinutes: {
        AM: 0,
        PM: 45
    },
    dayValid: (current: any) => {
        return current.isAfter(op.yesterday);
    }
};

/*custom logic for overwrite react-datetime time selection*/
class TimePartMutation {
    private TimePart: Element;
    private AM: Element | undefined;
    private PM: Element | undefined;
    private dayPart: Element | undefined;
    private hours: Element | undefined;
    private minutes: Element | undefined;
    private incrementHour: Element | undefined;
    private decrementHour: Element | undefined;
    private incrementMinute: Element | undefined;
    private decrementMinute: Element | undefined;
    private observer: any;
    public ampm: string = "AM";
    private form: any;
    private props: any;
    private parent: any;

    constructor(props: any) {
        this.TimePart = document.getElementsByClassName('time-part')[0];
        this.props = props?.props;
        this.parent = props?.parent;
        this.form = this.props.DateTime.data;
    }

    init() {
        if (this.TimePart) {
            const nodes = this.TimePart.getElementsByClassName('rdtCounter');
            this.dayPart = nodes[nodes.length - 1];

            //overhead timepicker events for am/pm
            this.assignApMpListeners(nodes);

            //overhead timepicker events for hour increment/decrement
            this.assignHoursListeners(nodes);

            //overhead timepicker events for minutes increment/decrement
            this.assignMinutesListeners(nodes);

            this.appendTitle();

            //set default day part
            this.changeDayPartActiveTab("AM");

            //set observe for watching day part auto change
            this.observeDayPartValue(this.dayPart)
        }
    }

    //am pm listeners
    assignApMpListeners(nodes: any) {
        //overhead timepicker events for am/pm

        if (this.dayPart) {
            const btns = this.dayPart.getElementsByClassName('rdtBtn');
            this.AM = btns[0];
            this.PM = btns[btns.length - 1];

            this.PM.addEventListener('mousedown', (e: any) => this.dayPartHandle(e, "PM"));
            this.AM.addEventListener('mousedown', (e: any) => this.dayPartHandle(e, "AM"));
        }
    }

    //hours listeners
    assignHoursListeners(nodes: any) {
        this.hours = nodes[0];

        if (this.hours) {
            const btns = this.hours.getElementsByClassName('rdtBtn');
            this.incrementHour = btns[0];
            this.decrementHour = btns[btns.length - 1];

            this.incrementHour.addEventListener('mousedown', (e: any) => this.hoursChangeHandle(e, "increment"));
            this.decrementHour.addEventListener('mousedown', (e: any) => this.hoursChangeHandle(e, "decrement"));
        }
    }

    //minutes listeners
    assignMinutesListeners(nodes: any) {
        this.minutes = nodes[1];

        if (this.minutes) {
            const btns = this.minutes.getElementsByClassName('rdtBtn');
            this.incrementMinute = btns[0];
            this.decrementMinute = btns[btns.length - 1];

            this.incrementMinute.addEventListener('mousedown', (e: any) => this.minutesChangeHandle(e, "increment"));
            this.decrementMinute.addEventListener('mousedown', (e: any) => this.minutesChangeHandle(e, "decrement"));
        }
    }

    appendTitle() {
        const head = this.TimePart.getElementsByTagName('thead')[0];

        if (head && this.dayPart) {
            head.appendChild(this.dayPart);

            const title = document.createElement("div");
            title.textContent = "Time";
            title.setAttribute('class', 'rdtTitle');
            let tr = head.firstChild;
            head.insertBefore(title, tr)
        }
    }

    dayPartHandle(e: any, type: string) {
        const rdtCount = this.dayPart?.getElementsByClassName('rdtCount')[0];
        if (rdtCount?.innerHTML.includes(type)) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            this.changeDayPartActiveTab(type, true);
        }
    }

    hoursChangeHandle(e: any, type: string) {
        //overhead timepicker events for hour increment/decrement

        const h = moment(this.form.time?.value || op.defaultTime).hours();
        const max = op.disabledHours[this.ampm];
debugger
        if (h === max && this.ampm === 'AM' && type === 'decrement' ||
            h === max && this.ampm === 'PM' && type === 'increment') {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    minutesChangeHandle(e: any, type: string) {
        //overhead timepicker events for hour increment/decrement

        const m = moment(this.form.time?.value || op.defaultTime).minutes();
        const h = moment(this.form.time?.value || op.defaultTime).hours();
        const maxM = op.disabledMinutes[this.ampm];
        const maxH = op.disabledHours[this.ampm];

        //prevent max date  time increment
        if (h === maxH && m === maxM && this.ampm === 'AM' && type === 'decrement' ||
            h === maxH && m === maxM && this.ampm === 'PM' && type === 'increment') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        //change hour
        let value = undefined;

        if (type === 'increment' && m === 45) {
            value =  moment(this.form.time?.value || op.defaultTime).hours(h+1);
            this.props.dateTimeFormChange({value, field: 'time'});
        } if (type === 'decrement' && m === 0) {
            value =  moment(this.form.time?.value || op.defaultTime).hours(h-1);
            this.props.dateTimeFormChange({value, field: 'time'});
        }
        //change hour end
    }

    observeDayPartValue(node: any = this.dayPart) {
        //day part auto change
        this.observer = new MutationObserver((mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation?.type === 'childList' && mutation?.removedNodes.length) {
                    console.log(mutation);
                    this.changeDayPartActiveTab(mutation)
                }
            }
        });

        this.observer.observe(node, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    changeDayPartActiveTab(node: any, reset: boolean = false) {
        //change am pm day part
        const innerText = typeof node === 'string' ? node : node.target.innerText;

        if (innerText.includes("AM")) {
            this.AM?.classList.add("active");
            this.PM?.classList.remove("active");
            this.ampm = "AM";

            if (reset) {
                this.props.dateTimeFormChange({value: op.defaultTime, field: 'time'});
            }

        } else if (innerText.includes("PM")) {
            this.PM?.classList.add("active");
            this.AM?.classList.remove("active");
            this.ampm = "PM";

            if (reset) {
                this.parent.changeForm(op.defaultTimePM, 'time');
            }

        }
    }

    disconnectObserve() {
        this.observer.disconnect();
    }

    clearListeners() {
        this.PM?.removeEventListener('mousedown', (e: any) => this.dayPartHandle(e, "PM"));
        this.AM?.removeEventListener('mousedown', (e: any) => this.dayPartHandle(e, "AM"));
        this.incrementHour?.removeEventListener('mousedown', (e: any) => this.hoursChangeHandle(e, "increment"));
        this.decrementHour?.removeEventListener('mousedown', (e: any) => this.hoursChangeHandle(e, "decrement"));
        this.incrementMinute?.removeEventListener('mousedown', (e: any) => this.minutesChangeHandle(e, "increment"));
        this.decrementMinute?.removeEventListener('mousedown', (e: any) => this.minutesChangeHandle(e, "decrement"));

        this.disconnectObserve()
    }
}
/*custom logic for overwrite react-datetime time selection */

class DateTime extends Component<HeaderProps, MainState> {
    state = {
        open: false,
        countyTimeZone: ''
    };
    private Time: any;

    componentDidMount(): void {
        this.Time = new TimePartMutation({props: this.props, parent: this});
        this.Time.init();

        if (this.props.default) {
            this.changeForm(moment(this.props.default.time), 'date');
            this.changeForm(moment(this.props.default.time), 'time');
            this.changeForm(this.props.default.zone, 'county_time_zone', true);
        }
    }
    componentDidUpdate(prevProps: Readonly<HeaderProps>, prevState: Readonly<MainState>, snapshot?: any): void {

        const countyTimeZone = this.props.CaseForm.data.county?.value?.timeZone;

        if (!_.isEqual(prevState.countyTimeZone, countyTimeZone) && countyTimeZone) {
            this.changeForm(countyTimeZone, 'county_time_zone');
            this.setState({countyTimeZone: _.clone(countyTimeZone)});
        }
    }
    componentWillUnmount() {
        this.props.dateTimeFormReset();
        this.Time.clearListeners()
    }

    changeForm = (e: any, field: string, validate: boolean = false): void => {
        const form = this.props.DateTime.data;
        let value = e;

        if (field === 'time' && !form.date.value) {
            this.props.dateTimeFormChange({value: moment(), field: 'date', validate});
        }
        if (field === 'date' && !form.time.value) {
            this.props.dateTimeFormChange({value: op.defaultTime, field: 'time', validate});
        }
        this.props.dateTimeFormChange({value, field, validate});
    };
    toggleCalendar = (close: boolean | null = null) => {
        if (close) {
            this.setState({open: false})
        } else {
            this.setState({open: !this.state.open})
        }
    };


    render() {

        const form = this.props.DateTime.data;
        const className = this.props.className;

        const formattedDate = moment(form.date?.value);


        return (
            <Fragment>
                <form className="w-100 consumer-style">
                    <div className="text-field-custom-mb">
                        <ClickAwayListener onClickAway={() => this.toggleCalendar(true)}>
                            <div>
                                <TextField
                                    onClick={() => this.toggleCalendar()}
                                    error={!!form?.county_time_zone?.error}
                                    helperText={form.county_time_zone?.error}
                                    value={form.date?.value ? moment(form.date?.value).format('MMM DD, YYYY').toUpperCase() + ' at ' + moment(form.time?.value).format('hh:mm A') : 'Date & Time'}
                                    label={'Date & Time'}
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: <InputAdornment position="end"><span
                                            className={`${form.date?.value && !this.state.open ? 'selected' : ''} date-endAdornment-icon`}/></InputAdornment>,
                                    }}
                                />
                                <div className={`${className} calendar-wrapper`}>
                                    <DatetimeComponent className={'date-part'}
                                                       isValidDate={op.dayValid}
                                                       open={this.state.open}
                                                       value={formattedDate || ''}
                                                       onChange={((e: Date) => this.changeForm(e, 'date'))}
                                                       input={false}
                                                       viewMode={'days'}
                                    />
                                    <DatetimeComponent className={'time-part'}
                                                       open={this.state.open}
                                                       value={form.time?.value || ''}
                                                       defaultValue={op.defaultTime}
                                                       timeConstraints={{
                                                           hours: {
                                                               min: 7,
                                                               max: 18
                                                           },
                                                           minutes: {
                                                               step: 15,
                                                           },
                                                       }}
                                                       onChange={((e: Date) => this.changeForm(e, 'time'))}
                                                       input={false}
                                                       viewMode={'time'}
                                    />
                                    {this.state.open && <button type="button"
                                                                className="picker-set-btn"
                                                                onClick={() => this.toggleCalendar()}>Set</button>}
                                </div>
                            </div>
                        </ClickAwayListener>
                    </div>
                </form>
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, Object>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {DateTime, CaseForm} = state;
    return {
        DateTime,
        CaseForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, Object>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        dateTimeFormReset: () => dispatch(dateTimeFormReset()),
        dateTimeFormChange: (data: any) => dispatch(dateTimeFormChange(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DateTime);
